import React, { useEffect, useState } from "react";
import {
    Card,
    Form,
    Input,
    Button,
    Row,
    Col,
    message,
    Typography,
    Spin
} from "antd";
import { SaveOutlined, UserOutlined } from "@ant-design/icons";
import axiosInstance from "../../configs";
import { getUser } from "../../utils/DataUser";

const { Title, Text } = Typography;
const { TextArea } = Input;

export default function MyProfile() {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const user = getUser();

    useEffect(() => {
        const loadProfile = async () => {
            try {
                const res = await axiosInstance.get(`/user-detail/${user.id_user}`);
                if (res.data) {
                    form.setFieldsValue(res.data);
                }
            } catch (err) {
                console.error("Load profile error:", err);
                message.error("Gagal memuat data profil");
            } finally {
                setLoading(false);
            }
        };
        if (user?.id_user) {
            loadProfile();
        }
    }, [user?.id_user, form]);

    const onFinish = async (values) => {
        setSaving(true);
        try {
            await axiosInstance.post("/user-detail", {
                id_user: user.id_user,
                ...values
            });
            message.success("Profil berhasil disimpan");
        } catch (err) {
            console.error("Save profile error:", err);
            message.error(err.response?.data?.error || "Gagal menyimpan profil");
        } finally {
            setSaving(false);
        }
    };

    if (loading) {
        return (
            <Card style={{ textAlign: "center", padding: 50 }}>
                <Spin size="large" />
                <div style={{ marginTop: 16 }}>Memuat profil...</div>
            </Card>
        );
    }

    return (
        <Card>
            <div style={{ marginBottom: 24, display: "flex", alignItems: "center" }}>
                <UserOutlined style={{ fontSize: 24, marginRight: 12, color: "#1890ff" }} />
                <Title level={4} style={{ margin: 0 }}>My Profile</Title>
            </div>

            <div style={{ marginBottom: 24, padding: 16, background: "#f5f5f5", borderRadius: 8 }}>
                <Row gutter={16}>
                    <Col span={12}>
                        <Text type="secondary">Username:</Text>
                        <div><Text strong>{user?.username}</Text></div>
                    </Col>
                    <Col span={12}>
                        <Text type="secondary">Nama Akun:</Text>
                        <div><Text strong>{user?.name || "-"}</Text></div>
                    </Col>
                </Row>
            </div>

            <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
            >
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            label="Nama Lengkap"
                            name="nama_lengkap"
                            rules={[{ required: true, message: "Nama lengkap wajib diisi" }]}
                        >
                            <Input placeholder="Nama lengkap sesuai identitas..." />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Jabatan"
                            name="jabatan"
                            rules={[{ required: true, message: "Jabatan wajib diisi" }]}
                        >
                            <Input placeholder="Jabatan / posisi..." />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item
                            label="Alamat"
                            name="alamat"
                        >
                            <TextArea rows={3} placeholder="Alamat lengkap..." />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            label="No. HP / WhatsApp"
                            name="no_hp"
                            rules={[{ required: true, message: "No HP wajib diisi" }]}
                        >
                            <Input placeholder="08xxxxxxxxxx" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Email"
                            name="email"
                            rules={[
                                { required: true, message: "Email wajib diisi" },
                                { type: "email", message: "Format email tidak valid" }
                            ]}
                        >
                            <Input placeholder="email@domain.com" />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            label="Password Email (opsional)"
                            name="password_email"
                        >
                            <Input.Password placeholder="Password email untuk keperluan sistem..." />
                        </Form.Item>
                    </Col>
                </Row>

                <Row justify="end" style={{ marginBottom: 60 }}>
                    <Button
                        type="primary"
                        htmlType="submit"
                        icon={<SaveOutlined />}
                        loading={saving}
                        size="large"
                    >
                        Simpan Profil
                    </Button>
                </Row>
            </Form>
        </Card>
    );
}
